import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import * as g from 'src/app/globals';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  colorList = {
    0: 'green', 1: 'aqua', 2: 'orange', 3: 'red', 4: 'purple', 5: 'fuchsia',
    6: 'gray', 7: 'navy', 8: 'blue'
  };
  constructor(private http: HttpClient) { }
  lang = g.language;
  urlSuffix = '&app=ITM-TOKENIZ&language=' + this.lang;
  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Methods': '*',
      'Access-Control-Allow-Credentials': 'true',
    }),
  };

  getEvents(url, data) {
    console.log(data);
    let params = '';
    data[0].forEach(item => {
      params += '&activitytype=' + item;
    });
    data[1].forEach((item, ind) => { // user: "[bg-color-blue][1]"
      params += '&user="[bg-color-' + this.colorList[ind] + '][' + item + ']"';
    });
    console.log('params', params);
    return this.http.get(
      `${g.apiBaseUrl
      }${url}?${params}`
    );
  }
  updateEvent(url, data) {
    return this.http.post(
      `${g.apiBaseUrl
      }${url}?id=${data.id}&start=${data.start}&end=${data.end}&allDay=${data.allDay}&Duration=${data.duration}`,
      JSON.stringify(data),
      this.httpOptions
    );
  }

  AddBP(url, fileId, cardCode) {
    const queryParams = { fileId: 'fileId', cardCode };
    return this.http.post(
      g.baseUrl + url + '?fil1Code=' + fileId + '&cardCode=' + cardCode,
      JSON.stringify(queryParams),
      this.httpOptions
    ).pipe(retry(1), catchError(this.errorHandler));
  }
  // Error handling
  errorHandler(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

}

